
//localStorage key names

export const  REDUX_USER_STATE = "persistantUser";
